export default "__VITE_ASSET__CaMdFvG___";